import CreateForm from '../components/book/CreateForm';
import Content from '../components/Content';

const BooksCreate = ({userStore}) => {
  return (
    <Content title="Criar novo Livro-Filho" userStore={userStore}>
      <CreateForm userStore={userStore} onSave={() => {}} />
    </Content>
  )
}

export default BooksCreate
